export default {
  mobile: '576px',
  tablet: '768px',
  notebook: '992px',
  desktop: '1200px'
};
